








import { Component, Vue } from 'vue-property-decorator'

@Component({})
export default class ViewContents extends Vue {}
